<template>
	<modal
		title="Clear Cart?"
		first-button-text="keep cart"
		second-button-text="YES"
		:dark-theme="darkTheme"
		:is-loading="isLoading"
		:first-button-action="firstButtonAction"
		:second-button-action="secondButtonAction"
		@close="closeModal"
	>
		<div>
			All items will be removed
		</div>
	</modal>
</template>

<script>
import Modal from './Modal.vue'
export default {
	name: 'RemoveCartConfirmationModal',

	components: { Modal },

	props: {
		isLoading: {
			type: Boolean,
			default: false
		},

		firstButtonAction: {
			type: Function,
			default: () => {}
		},

		secondButtonAction: {
			type: Function,
			default: () => {}
		},

		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		closeModal() {
			this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss"></style>
